import { Reducer } from "redux";
import { SET_VERTEX_SELECTION, SET_VERTICES, SET_VERTICES_MODE } from "../actions/verticesActions";
import { TimestampsDict, TimestampsStringDict } from "./timestampsReducer";

export const verticesSelectionOptions = [
    { key: 0, value: 0, text: "Closest vertex to the RefProg" },
    { key: 1, value: 1, text: "Relevant subset" },
    { key: 2, value: 2, text: "All vertices" },
    { key: 3, value: 3, text: "Domain vertices" },
];

export const getVertices = (verticesMap: TimestampsStringDict, timestamps: number[]) => {
    const result: TimestampsDict = {};
    //hack, we will set 2a value for hour 2, and 2b for hour 222; 25h timestamp
    if (timestamps.includes(2) && 222 in verticesMap) {
        timestamps.push(222);
    }
    timestamps.forEach(timestamp => {
        let verticesString: string = verticesMap[timestamp];
        if (verticesString) {
            verticesString = verticesString.replace(/\s/g, "");
            const verts = verticesString.split(",").map(Number);
            if (verts[0] === 0) verts.shift();
            if (verts[verts.length - 1] === 0) verts.pop();
            result[Number(timestamp)] = verts;
        }
    });
    return result;
};

export const getVerticesString = (verticesObj: TimestampsDict, timestamps: number[]) => {
    const result: TimestampsStringDict = {};
    timestamps.forEach(timestamp => {
        const vertices: number[] = verticesObj[timestamp];
        if (vertices) {
            const verticesString = vertices.toString();
            result[Number(timestamp)] = verticesString;
        }
    });
    return result;
};

export interface VerticesState {
    vertices: TimestampsStringDict;
    verticesMode: string;
    vertexSelection: number;
}

const initialState: VerticesState = {
    vertices: {},
    verticesMode: "manual",
    vertexSelection: -1,
};

export const verticesReducer: Reducer<VerticesState> = (
    state: VerticesState = initialState,
    action: any
): VerticesState => {
    switch (action.type) {
        case SET_VERTICES:
            return {
                ...state,
                vertices: action.vertices,
            };
        case SET_VERTICES_MODE:
            return {
                ...state,
                verticesMode: action.mode,
            };
        case SET_VERTEX_SELECTION:
            return {
                ...state,
                vertexSelection: action.selection,
            };

        default:
            return state;
    }
};
